import { gql } from "@apollo/client";

export const SET_DEFAULT_CARD_AFTER_POLLING = gql`
  mutation setDefaultCardAfterPolling($cardID: Int!) {
    setDefaultCard(cardID: $cardID)
  }
`;
